import {LOGING_ARE_LOADING, LOGING_HAVE_ERROR, LOGING_FETCH_DATA_SUCCESS} from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function LogingReducer (state = initialState, action) {
    switch (action.type) {
        case LOGING_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case LOGING_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case LOGING_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.Login,
                loading:false,
            }

        default:
            return state;
    }
}
